import React, { Component } from 'react';
import Global from '../../../Global';
import RoamingCard from './RoamingCard';
import './Roaming2.css';

class Roaming2 extends Component {

	constructor( props ) {
		super(props);

		this.state = {
			banner: false,
			roamingData:{},
			allRoamingPlan:[],
			startQuiz:false,
			viewAllRoaming:false,
			viewAllRoamingPost:false,
			currentQuestion:1,
			previousQuestion: 0,
			quizState:[],
			defaultQuizState:[]
		}

		this.handleFindRoamingPlan = this.handleFindRoamingPlan.bind(this);
		this.handleQuizRadioClick = this.handleQuizRadioClick.bind(this);
		this.handleQuizRadioUIClick = this.handleQuizRadioUIClick.bind(this);
		this.handleQuizNextClick = this.handleQuizNextClick.bind(this);
		this.handleQuizPrevClick = this.handleQuizPrevClick.bind(this);
		this.handleViewAllRoaming = this.handleViewAllRoaming.bind(this);
		this.handleViewAllRoamingGoBack = this.handleViewAllRoamingGoBack.bind(this);
	}

	componentWillMount() {

		var url = Global.getAPI(this.props.urlAPI);
		var self = this;
		fetch(url)
			.then(function(response) {
				if (response.status >= 400) {
					throw new Error("Error API: Roaming");
				}
				return response.json();
			})
			.then(function(data) {

				if( Object.keys(data).length == 1 ) {
					self.setState({
						banner:true,
						roamingData:data,
						background: data.general
					}, function() {
						window.THREE_MAIN.homeRoaming.load();
					});
				} else {
					var quizStateArray = self.getDefaultState(data);
					var allRoamingPlanArray = self.getAllRoamingPlan(data);

					// get random background image and title
					var background = self.getRandomBackground(data);

					self.setState({
						roamingData:data,
						quizState:quizStateArray,
						allRoamingPlan:allRoamingPlanArray,
						background: background
					}, function() {
						window.THREE_MAIN.homeRoaming.load();
					});
				}

			}).catch((error) => {
			console.log('Error API: Roaming')
		});

	}

	getDefaultState(data) {
		var quizStateArray = [];
		var obj = {};
		if( typeof data != "undefined" ) {
			obj = data;
		} else {
			obj = this.state.roamingData;
		}

		var question = 1;
		for( var propertyName in obj ) {
			var obj = {};
			// first radio selected by default
			if( propertyName.indexOf('question') != -1 ) {
				obj['answer'] = "q"+question+"a1";
				quizStateArray.push(obj);
				question++;
			}
		}

		return quizStateArray;
	}

	getAllRoamingPlan(data) {
		var allRoamingPlan = [];
		for( var propertyName in data.plans ) {
			allRoamingPlan.push( data.plans[propertyName] );
		}

		return allRoamingPlan;
	}

	getRandomBackground(data) {
		var randomNum = Math.floor(Math.random() * Math.floor(data.general.scenes.length));

		return data.general.scenes[randomNum];
	}

	handleFindRoamingPlan(e) {

		if( !this.state.banner ) {
			this.setState({
				startQuiz:!this.state.startQuiz
			}, function() {
				window.THREE_MAIN.homeRoaming.viewAllRoamingScrollTo();
			});
		} else {
			window.location.href = this.state.roamingData.general.ctaUrl;
		}

	}

	handleQuizNextClick() {

		Global.byClassNameAddClass("quiz-block-wrapper","is-fadeout");

		setTimeout(function() {
			Global.byClassNameRemoveClass("quiz-block-wrapper","is-fadeout");

			// reached the end (showing plans)
			if( this.state.currentQuestion == "end" ) {

				this.setState({
					currentQuestion:1,
					previousQuestion:this.state.currentQuestion,
					quizState:this.getDefaultState()
				}, function() {
					window.THREE_MAIN.homeRoaming.roamingQuizScrollTo();
				});

			} else {

				if( this.state.currentQuestion == this.state.quizState.length ) {
					this.setState({
						currentQuestion:"end",
						previousQuestion:this.state.currentQuestion
					}, function() {
						window.THREE_MAIN.homeRoaming.roamingQuizScrollTo();
					});
				} else {
					var currentAnswer = this.state.quizState[this.state.currentQuestion-1].answer;
					var currentResult = this.state.roamingData.results[currentAnswer];

					if( typeof currentResult != "undefined" && typeof currentResult.result != "undefined" ) {
						// multiple continents

						// clear the 'next' answers
						var quizState = this.state.quizState;
						for( let i = this.state.currentQuestion; i < quizState.length; i++ ){
							quizState[i].answer = "";
						}

						this.setState({
							currentQuestion:"end",
							previousQuestion: this.state.currentQuestion,
							quizState:quizState
						}, function() {
							window.THREE_MAIN.homeRoaming.roamingQuizScrollTo();
						});

					} else {
						var nextQuestion = this.state.currentQuestion + 1;
						this.setState({
							currentQuestion:nextQuestion,
							previousQuestion: this.state.currentQuestion
						}, function() {
							window.THREE_MAIN.homeRoaming.roamingQuizScrollTo();
						});
					}
				}

			}
		}.bind(this), 1000);

	}

	handleQuizPrevClick() {

		if( this.state.currentQuestion == 1 ) {

			this.setState({
				startQuiz:!this.state.startQuiz,
				quizState:this.getDefaultState()
			});

		} else {

			var currentQuestion = this.state.previousQuestion--;
			var previousQuestion = currentQuestion - 1;

			this.setState({
				currentQuestion:currentQuestion,
				previousQuestion:previousQuestion
			});

		}

	}

	getQuizBlockHTML() {

		if( this.state.currentQuestion != "end" ) {

			var questionObj = this.state.roamingData["question"+this.state.currentQuestion];
			var questionArray = [];

			// filter the questions to ensure they are the right ones based on the region answers
			if( this.state.previousQuestion > 0 ) {
				var answerArray = [];
				var answerDataArray = [];
				for( let i = 0; i < this.state.currentQuestion - 1; i++ ) {

					if( this.state.quizState[i].answer != "" ) {
						if( i == 0 ) {
							answerDataArray = this.state.roamingData.results[this.state.quizState[i].answer];
						} else {
							answerDataArray = answerDataArray[this.state.quizState[i].answer];
						}
					}
				}

				for( var propertyName in answerDataArray ) {
					answerArray.push(propertyName);
				}

				questionArray = this.getQuizListItemInclude( answerArray, questionObj.answers );

				var quizBlockInnerHTML = this.getQuizListHTML(questionArray);
			} else {
				var quizBlockInnerHTML = this.getQuizListHTML(questionObj.answers);
			}

			var title = questionObj.label;
			var legend = questionObj.question;
			var ctaLabel = questionObj.ctaLabel;

			var disabled = true;
			if( this.state.quizState[this.state.currentQuestion-1].answer != "" ) {
				var disabled = false;
			}

		} else {

			var obj = {};
			for( let i = 0; i < this.state.quizState.length; i++) {
				if( i == 0 ) {
					obj = this.state.roamingData["results"][this.state.quizState[0].answer];
				} else {
					if( this.state.quizState[i].answer != "" ) {
						obj = obj[this.state.quizState[i].answer];
					}

				}
			}

			var questionObj = obj.result;
			var quizBlockInnerHTML = this.getQuizBlockEndHTML(questionObj.plans);

			var title = questionObj.headline1;
			var legend = questionObj.headline2;
			var ctaLabel = this.state.roamingData.general.searchAgainLabel;
			var disabled = false;
		}

		return (
			<div className="quiz-block-wrapper react-row">
				<div className="quiz-block">
					<span className="quiz-title">{title}{'\u00A0'}</span>
					<fieldset>
						<div className="fieldset-header">
							<button type="button" className="btn-image btn-go-back" onClick={this.handleQuizPrevClick}><img src="assets/images/icons/icon-chev-left-white.png" alt="back" /></button>
							<legend>{legend}</legend>
						</div>
						{quizBlockInnerHTML}
					</fieldset>
				</div>
				<button type="button" id="quiz-next" className="btn btn-invisible" disabled={disabled} onClick={this.handleQuizNextClick}>{ctaLabel}</button>
			</div>
		);

	}

	getQuizListItemInclude(answerArray, questionObj) {

		var array = [];

		for( let i = 0; i < questionObj.length; i++ ) {
			if( answerArray.indexOf(questionObj[i].value) > -1 ) {
				array.push( questionObj[i] );
			}
		}

		return array;

	}

	getQuizBlockEndHTML(plans) {

		return (
			<RoamingCard type="quizRoaming" roamingData={this.state.roamingData} plans={plans} />
		);

	}

	getQuizBlockEndInnerHTML(details) {

		let html = details.map( ( detail, index ) =>
			<li key={index} className="col-xs-6">
				<div className="deal-wrapper">
					<span className="deal-property">{detail.headline}</span>
					<p className="deal-price">${detail.price}</p>
				</div>
			</li>
		);

		return (
			<ul className="quiz-card-deals row">
				{html}
			</ul>
		)

	}

	getQuizListHTML(answers) {

		var radioValue = this.state.quizState[this.state.currentQuestion-1].answer;

		let html = answers.map( (answer, index) =>
			<li key={index}>
				<span className={"is-radio " + (answer.value == radioValue ? "is-checked" : "") } onClick={this.handleQuizRadioUIClick}><img src="assets/images/icons/icon-radio.png" alt="" /></span>
				<input type="radio" name="roaming-continent" id={"roaming-continent-"+index} className="" checked={answer.value == radioValue ? "checked" : ""} value={answer.value} onChange={this.handleQuizRadioClick} />
				<label htmlFor={"roaming-continent-"+index}>{answer.label}</label>
			</li>
		);

		return (
			<ul className="quiz-list">
				{html}
			</ul>
		);

	}

	handleQuizRadioClick(e) {
		var value = e.currentTarget.value;
		var quizState = this.state.quizState;

		quizState[this.state.currentQuestion-1].answer = value;

		this.setState({
			quizState:quizState
		});

	}

	handleQuizRadioUIClick(e) {
		e.currentTarget.nextSibling.click();
	}

	handleViewAllRoaming() {

		var self = this;

		self.setState({
			viewAllRoaming:true
		}, function() {

			setTimeout(function() {

				self.setState({
					viewAllRoamingPost:true
				});

				window.THREE_MAIN.homeRoaming.viewAllRoamingScrollTo();

			},1000);

		});

	}

	handleViewAllRoamingGoBack() {

		this.setState({
			viewAllRoaming:false,
			viewAllRoamingPost:false
		});

	}

	render() {

		if( Object.keys(this.state.roamingData).length === 0 ) {
			return false;
		} else {

			var background = this.state.background;

			var containerStyle = {
				backgroundImage: 'url(' + background.image + ')',
			};

			var containerMobileStyle = {
				backgroundImage: 'url(' + background.imageMob + ')',
			}

			// section roaming class
			var classNameSectionRoaming = "";

			if( this.state.startQuiz ) {
				classNameSectionRoaming += "is-expand";
			}

			if( this.state.viewAllRoaming ) {
				classNameSectionRoaming += " is-offcanvas";
			}

			if( this.state.viewAllRoamingPost ) {
				classNameSectionRoaming += " post-offcanvas";
			}

			if( this.state.banner ) {
				classNameSectionRoaming += " is-roaming-banner";
			}

			return (
				<section id="section-roaming" className={classNameSectionRoaming}>
					<div className="container">
						<div className="container-left background-hidden-xs" style={containerStyle}>
							{/*<div className="section-overlay"></div>*/}
							{!this.state.banner &&
							<button type="button" href="javascript:void(0)" className="btn-image tab-view-more" onClick={this.handleViewAllRoaming}>
              <span className="tab-view-more-inner">
                <span className="tab-view-more-background"></span>
                <span className="tab-view-more-label">{this.state.roamingData.general.viewAllLabel}</span>
                <img src="assets/images/icons/icon-chev-right-white.png" className="chev-right hidden-xs" alt="" />
              </span>
							</button>
							}
							<div className="container-left-inner background-visible-xs" style={containerMobileStyle}>

								<div className="section-roaming-inner">
									<div className="section-roaming-col-left">
										<div className="container-inner">
											{!this.state.banner &&
											<div className="section-overlay section-block-offcanvas section-roaming-quiz">
												{this.getQuizBlockHTML()}
											</div>
											}{/*<!-- section-roaming-quiz END -->*/}
											<div className="section-roaming-content">
												<div className="row section-roaming-top">
													<div className="section-roaming-top-inner col-xs-6">
														<span className="roaming-city" style={{color: "black"}}>{this.state.background.headline}</span>
													</div>
												</div>
												<div className="row section-roaming-body">
													<div className="section-roaming-body-inner col-xs-12 col-lg-9">
														{!this.state.banner ? <span class="header-title">{this.state.roamingData.general.headline1}<span className="line-break" />{this.state.roamingData.general.headline2}</span> : <span class="header-title" style={{color: "black"}}>{this.state.roamingData.general.headline}</span>}
														<p style={{color: "black"}}>
															{this.state.roamingData.general.text}
														</p>
													</div>
												</div>
												<div className="row section-roaming-footer">
													<div className="section-roaming-footer-inner col-xs-12">
														<button style={{color: "black", borderColor: "black"}} type="button" id="btn-find-my-roaming-plan" className="btn btn-invisible" onClick={this.handleFindRoamingPlan}>{this.state.roamingData.general.ctaLabel}</button>
													</div>
												</div>
											</div>{/*<<!-- section-roaming-content END -->*/}

										</div>{/*<!-- container inner END -->*/}
									</div>
									<div className="section-roaming-col-right">
									</div>
								</div>{/*section roaming inner*/}
							</div>{/*container mobile*/}
						</div>{/*container desktop*/}
						{!this.state.banner &&
						<div className="section-block-offcanvas section-roaming-view-all">
							{this.state.viewAllRoaming &&
							<div className="quiz-block">
								<span className="quiz-title">{this.state.roamingData.general.allRoamingDetailsTitle}</span>

								<fieldset>
									<div className="fieldset-header">
										<button type="button" className="btn-image btn-go-back" onClick={this.handleViewAllRoamingGoBack}><img src="assets/images/icons/icon-chev-left-white.png" alt="back" /></button>
									</div>
									<RoamingCard type="allRoaming" cards={this.state.allRoamingPlan} />
								</fieldset>

							</div>
							}
						</div>
						}{/* section-roaming-quiz */}
					</div>
				</section>

			);
		}
	}
}

export default Roaming2;
